<template>
  <div class="alert alert-info wrapper">
    <div class="text"> Please upload completed Application to become an ACA Judge.
      <br>
      Note – incomplete applications will not be considered.
    </div>
    <button class="btn btn-block btn-outline-primary button-download mb-2" @click="openDocument">Download Blank Form
    </button>
  </div>
</template>

<script>
export default {
  name: "DownloadBlankFormAlert",
  methods: {
    openDocument() {
      if (this.$route.params.member_id) {
        window.open(`${this.$openApplicationFilePath}`, '_blank')
      } else {
        window.open(`${this.$trialApplicationFilePath}`, '_blank')
      }
    }
  }
}

</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
}

.text {
  width: 50%;
  display: flex;
  align-items: center;
}

.button-download {
  width: 230px;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Application/components/DownloadBlankAlert.vue